export const pythonDefaultSource = `# Example of Python 2-style exception handling
# This codemod will modernize exception syntax

# Old except syntax with comma
try:
    with open("file.txt", "r") as f:
        data = f.read()
except IOError, e:
    print("Error reading file: {}".format(e))

# Another example with variable
try:
    config = json.loads(data)
except ValueError, err:
    logging.error("Invalid JSON format: %s", err)

# Handling multiple exceptions (old style)
try:
    result = process_data(data)
except (KeyError, TypeError), error:
    print("Processing failed: {}".format(error))

# Not everything needs updating
try:
    # This is already using modern syntax
    response = requests.get("https://api.example.com/data")
    response.raise_for_status()
except requests.RequestException as e:
    print(f"API request failed: {e}")`;

export const pythonDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";

async function transform(root: SgRoot): Promise<string | null> {
  const rootNode = root.root();

  // Find all Python 2-style exception handlers (using comma instead of 'as')
  const nodes = rootNode.findAll({
    rule: {
      // Use AST-based approach to find commas inside except clauses
      pattern: ",",
      inside: {
        kind: "except_clause"
      }
    }
  });

  const edits = nodes.map(node => {
    // Replace the comma with "as"
    return node.replace(" as");
  });

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const pythonDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: python2-to-python3-except-clause
language: python
rule:
  pattern: ","
  inside:
    kind: except_clause
fix: " as"
`.trim();
